import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { HttpClient } from '@angular/common/http';
import { Polygon, MultiPolygon, FeatureCollection, Feature, Point } from '@turf/helpers';
import { firstValueFrom, filter, take } from 'rxjs';
import { ChartData } from 'chart.js';
import { MapHelperService } from 'src/services/map-helper.service';
import { LayerAPIService } from 'src/app/features/shared/services/API/LayersAPI.service';
import { UnileverService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Unilever.service';
import { PolygonSelectorWithLevelsComponent } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/components/polygon-selector-with-levels/polygon-selector-with-levels.component';
import { PolygonSelectorServiceType } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/helpers/EnumSelectorServices';
import { HierarchyLevel, SelectionHistoryItem, SelectionChangeEvent } from 'src/app/features/map-features/ui/organisms/polygon-selector-with-levels/models/polygon-selector-with-levels.models';
import { TwoLevelsSelectorService } from '../../services/TwoLevelsSelector.service';

@Component({
  selector: 'polygon-selector-with-levels-control-two-levels',
  templateUrl: './polygon-selector-with-levels-control-two-levels.component.html',
  styleUrls: ['./polygon-selector-with-levels-control-two-levels.component.css'],
})
export class PolygonSelectorWithLevelsControlTwoLevelsMapComponent implements OnInit, OnDestroy {

  @Output() selectionChange = new EventEmitter<{ first: string, second: string }>();
  @Input() isPolygonSelectionWithevelsActive: boolean = true;
  
  // configuración del selector de poligonos
  @ViewChild('polygonSelector') polygonSelector: PolygonSelectorWithLevelsComponent;

  isInitializing: boolean = true;


  hierarchyLevels: HierarchyLevel[] = [];
  selectorWithLevelsPrefixAdd: string = 'potential-zones';
  serviceType = (PolygonSelectorServiceType.Potential_Zones);


  selectedHistory: SelectionHistoryItem[] = [];
  firstZone: { name: string, isSelected: boolean } = { name: 'Región Seleccionada', isSelected: false };
  secondZone: { name: string, isSelected: boolean, id: string} = { name: 'Zona Seleccionada', isSelected: false, id: null };

  constructor(
    private mapHelperService: MapHelperService,
    private http: HttpClient,
    public twoLevelsSelectorService: TwoLevelsSelectorService,
    private layersAPIService: LayerAPIService,
    private unileverService: UnileverService
  ) {
  }

  ngOnInit() {
    this.initializeComponent();
  }

  ngOnDestroy(): void {
    this.twoLevelsSelectorService.setIsVisible(false);
    this.twoLevelsSelectorService.destroyLayers();
  }

  async initializeComponent(): Promise<void> {
    this.isInitializing = true;
    this.hierarchyLevels = await this.twoLevelsSelectorService.loadLayers();
    console.log("jerarquia selector",this.hierarchyLevels);
    
    this.isInitializing = false;
    this.twoLevelsSelectorService.setIsVisible(true);
    // this.twoLevelsSelectorService.initializePotentialZonesMapSection();
  }



  onHierarchySelectionChange(event: SelectionChangeEvent): void {
    console.log('zonas potenciales, cambio de seleccion', event);
    this.selectedHistory = event.history;

    if (event.history.length === 0) {
      this.resetZones();
      return;
    }

    if (event.history.length >= 1) {
      const firstSelection = event.history[0];
      this.firstZone = {
        name: firstSelection.description || 'Región Seleccionada',
        isSelected: true
      };
    }else{
      this.firstZone = { name: 'Región Seleccionada', isSelected: false };
    }

    if (event.history.length >= 2) {
      const secondSelection = event.history[1];
      this.secondZone = {
        name: secondSelection.description || 'Zona Seleccionada',
        isSelected: true,
        id: secondSelection.selectedId
      };

      if (this.polygonSelector) {
        this.isPolygonSelectionWithevelsActive = false;
      }
      this.selectionChange.emit({ first: this.firstZone.name, second: this.secondZone.name });
    }else{
      this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null};
    }
  }

  

  resetZones(): void {
    this.firstZone = { name: 'Región Seleccionada', isSelected: false };
    this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null };
  }


  async goBack(): Promise<void> {
    if (this.secondZone.isSelected) {
      this.secondZone = { name: 'Zona Seleccionada', isSelected: false, id: null };
      
      // Reactivar el selector de polígonos con niveles
      if (this.polygonSelector) {
        this.isPolygonSelectionWithevelsActive = true;
        this.polygonSelector.restoreFullGeoJsonForCurrentLevel();
      }
    } else {
      if (this.polygonSelector) {
        await this.polygonSelector.goToPreviousLevel();
      }
    }
  }

  async resetToStart(resetCamera: boolean): Promise<void> {
    this.resetZones();
    if (resetCamera) {
      this.mapHelperService.FlyToCamera(
        this.mapHelperService.Lat.toString(),
        this.mapHelperService.Lng.toString(),
        this.mapHelperService.Zoom.toString(),
        0
      );
    }
    
    if (this.polygonSelector) {
      const resetAll = false;
      await this.polygonSelector.resetToInitialLevel(resetAll);
    }
  }

}
